import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ClusterForm } from '@/components/forms/ClusterForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateClusterPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/organization/clusters')
  }

  const handleCancel = () => {
    navigate('/organization/clusters')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Cluster</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new cluster to the organization hierarchy
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <ClusterForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
